"use strict";
// Copyright 2017-2018 Stratumn SAS. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var b64 = __importStar(require("base64-js"));
var errors = __importStar(require("./errors"));
var evidence_1 = require("./evidence");
var link_1 = require("./link");
var chainscript_pb_1 = require("./proto/chainscript_pb");
/**
 * Deserialize a segment.
 * @param segmentBytes encoded bytes.
 * @returns the deserialized segment.
 */
function deserialize(segmentBytes) {
    var segment = chainscript_pb_1.stratumn.chainscript.Segment.decode(segmentBytes);
    return new Segment(segment);
}
exports.deserialize = deserialize;
/**
 * Convert an plain object to a segment.
 * @param segment plain object.
 */
function fromObject(segment) {
    return new Segment(chainscript_pb_1.stratumn.chainscript.Segment.fromObject(segment));
}
exports.fromObject = fromObject;
/**
 * A segment describes an atomic step in your process.
 */
var Segment = /** @class */ (function () {
    function Segment(pbSegment) {
        if (!pbSegment.link) {
            throw errors.ErrLinkMissing;
        }
        this.pbLink = pbSegment.link;
        this.pbSegment = pbSegment;
        if (!this.pbSegment.meta) {
            this.pbSegment.meta = new chainscript_pb_1.stratumn.chainscript.SegmentMeta();
        }
        var link = new link_1.Link(this.pbLink);
        this.pbSegment.meta.linkHash = link.hash();
    }
    /**
     * The segment can be enriched with evidence that the link was saved
     * immutably somewhere.
     * @param e evidence.
     */
    Segment.prototype.addEvidence = function (e) {
        e.validate();
        if (this.getEvidence(e.backend, e.provider)) {
            throw errors.ErrDuplicateEvidence;
        }
        var pbEvidence = new chainscript_pb_1.stratumn.chainscript.Evidence();
        pbEvidence.version = e.version;
        pbEvidence.backend = e.backend;
        pbEvidence.provider = e.provider;
        pbEvidence.proof = e.proof;
        var segmentMeta = this.pbSegment.meta;
        segmentMeta.evidences.push(pbEvidence);
    };
    /**
     * Return all the evidences in this segment.
     * @returns evidences.
     */
    Segment.prototype.evidences = function () {
        var segmentMeta = this.pbSegment.meta;
        return segmentMeta.evidences.map(evidence_1.fromProto);
    };
    /**
     * Return all the evidences of a specific backend.
     * @param backend of the expected evidences.
     * @returns evidences.
     */
    Segment.prototype.findEvidences = function (backend) {
        var segmentMeta = this.pbSegment.meta;
        return segmentMeta.evidences
            .filter(function (e) { return e.backend === backend; })
            .map(evidence_1.fromProto);
    };
    /**
     * Retrieve the evidence for the given backend and provider (if one exists).
     * @param backend evidence backend.
     * @param provider evidence backend instance.
     * @returns the evidence or null.
     */
    Segment.prototype.getEvidence = function (backend, provider) {
        var segmentMeta = this.pbSegment.meta;
        var evidences = segmentMeta.evidences;
        for (var _i = 0, evidences_1 = evidences; _i < evidences_1.length; _i++) {
            var current = evidences_1[_i];
            if (current.backend === backend && current.provider === provider) {
                return evidence_1.fromProto(current);
            }
        }
        return null;
    };
    /**
     * The segment's link is its immutable part.
     * @returns the segment's link.
     */
    Segment.prototype.link = function () {
        return new link_1.Link(this.pbLink);
    };
    /**
     * Get the hash of the segment's link.
     * @returns the link's hash.
     */
    Segment.prototype.linkHash = function () {
        return this.pbSegment.meta.linkHash;
    };
    /**
     * Serialize the segment.
     * @returns segment bytes.
     */
    Segment.prototype.serialize = function () {
        return chainscript_pb_1.stratumn.chainscript.Segment.encode(this.pbSegment).finish();
    };
    /**
     * Convert to a plain object.
     * @argument conversionOpts specify how to convert certain types
     * @returns a plain object.
     */
    Segment.prototype.toObject = function (conversionOpts) {
        return chainscript_pb_1.stratumn.chainscript.Segment.toObject(this.pbSegment, conversionOpts);
    };
    /**
     * Validate checks for errors in a segment.
     */
    Segment.prototype.validate = function () {
        if (!this.pbSegment.meta) {
            throw errors.ErrSegmentMetaMissing;
        }
        if (!this.linkHash() || this.linkHash().length === 0) {
            throw errors.ErrLinkHashMissing;
        }
        if (b64.fromByteArray(this.linkHash()) !==
            b64.fromByteArray(this.link().hash())) {
            throw errors.ErrLinkHashMismatch;
        }
        this.link().validate();
    };
    return Segment;
}());
exports.Segment = Segment;
//# sourceMappingURL=segment.js.map